// extracted by mini-css-extract-plugin
export default {"componentBlock":"avMjONmN9y2txDOLCZ5EJ","componentBlockContent":"_1qsmstR8FYLLi9YdTuya2y"};